export const GoogleSheetsIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <path fill="#43a047" d="M37 45H11a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h19l11 11v27a4 4 0 0 1-4 4" />
    <path fill="#c8e6c9" d="M40 14H30V4z" />
    <path fill="#2e7d32" d="M30 14h10v1l-11-1" />
    <path
      fill="#e8f5e9"
      d="M31 23H17a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V25a2 2 0 0 0-2-2m-8 14h-6v-4h6zm0-6h-6v-4h6zm8 6h-6v-4h6zm0-6h-6v-4h6z"
    />
  </svg>
);
